module.exports = __webpack_public_path__ + "static/media/400336_01.4566edfa.png";